import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import UsersList from '../SpaServices/UsersList';
import { ConfirmPopUp } from '../../utils/dialogue/ConfirmPopUp';
import ReservationDates from './ReservationDates';
import { ReservationDatesLoader } from '../../utils/loaders/ReservationDatesLoader';
import CollapseContainer from '../MobileView/CollapseContainer';
import { HashLink as Link } from 'react-router-hash-link';
import { formatName } from '../../utils/spaUtils'

class ReservationTimeSlots extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showUserList: false,
            users: [],
            cruiseDates: [],
            showPopUp: false,
            warningText: '',
        }
        this.warningRef = null;
        this.scrollToMyRef = this.scrollToMyRef.bind(this);
        this.noteRef = '';
        this.onSelectReserveDate = this.onSelectReserveDate.bind(this);
        this.onClosePopUp = this.onClosePopUp.bind(this)
        this.showUserList = this.showUserList.bind(this);
        this.onCollapseClose = this.onCollapseClose.bind(this);
    }

    scrollToMyRef() {
        document.getElementById('cancellation-heading').setAttribute('tabindex', '-1');
        document.getElementById('cancellation-heading').focus();
        window.scrollTo(0, this.props.serviceref.offsetTop)
    }
    componentDidMount() {
        let { services } = this.props;
        if (!services.selectedService.isNoAvailable) {
            this.props.actions.getReservationDates();
        }
    }
    componentWillReceiveProps(next) {
        next.conflictMsg !== this.props.conflictMsg && next.conflictMsg.length > 0 &&
            window.scrollTo(0, this.noteRef.offsetTop + 50);
    }
    onUserClick=(selectedUser)=> {
        let { selectedService } = this.props.services;
        if (selectedUser.PassengerDetail.Age < 18) {
            if (selectedUser.PassengerDetail.Age <= 12 || (selectedService.serviceGroup !== 'zspaervicesforteens' && selectedService.serviceGroup !== 'zspaforteens')) {
                let warningText = 'Due to age restrictions ' + selectedService.treatmentDesc + ' is not available for ' + formatName(selectedUser.PassengerDetail.Name.FirstName) + ' ' + formatName(selectedUser.PassengerDetail.Name.LastName)
                this.setState({ warningText });
                return
            }
        }
        this.setState({ warningText: '' });
        this.props.actions.selectGuest(selectedUser);
    }

    onSelectReserveDate(date, inCart) {
        let { selectedGuestDetails = {}, selectedService } = this.props.services;
        let warningText = false;
        if (!isEmpty(selectedGuestDetails) && selectedGuestDetails.PassengerDetail.Age < 18) {
            if (selectedGuestDetails.PassengerDetail.Age <= 12 || (selectedService.serviceGroup !== 'zspaervicesforteens' && selectedService.serviceGroup !== 'zspaforteens'))
                warningText = 'Due to age restrictions ' + selectedService.treatmentDesc + ' is not available for ' + selectedGuestDetails.PassengerDetail.Name.FirstName + ' ' + selectedGuestDetails.PassengerDetail.Name.LastName
        }
        if (isEmpty(selectedGuestDetails)) {
            warningText = 'Please Select a Guest to Continue Reservation';
        }
        if (warningText) {
            this.setState({ warningText }, () => {
                let warnDom = document.getElementById('reservation-warn-container');
                if (warnDom) {
                    warnDom.setAttribute('tabindex', '-1');
                    warnDom.focus();
                }
            });
            window.scrollTo(0, this.warningRef.offsetTop + 50);
            return;
        }

        this.props.actions.selectReserveDate(date);
        //Checking exact inequality for undefined
        if (inCart !== undefined)
            this.onReserveService(date[0], inCart)
        this.setState({ warningText: '' });
    }

    onReserveService=(service, inCartClass)=> {
        let { reservations = {} } = this.props;
        let { selectedGuestDetails = {}, selectedService } = this.props.services;
        let warningText = false;
        if (!isEmpty(selectedGuestDetails) && selectedGuestDetails.PassengerDetail.Age < 18) {
            if (selectedGuestDetails.PassengerDetail.Age <= 12 || (selectedService.serviceGroup !== 'zspaervicesforteens' && selectedService.serviceGroup !== 'zspaforteens'))
                warningText = 'Due to age restrictions ' + selectedService.treatmentDesc + ' is not available for ' + selectedGuestDetails.PassengerDetail.Name.FirstName + ' ' + selectedGuestDetails.PassengerDetail.Name.LastName
        }
        if (isEmpty(selectedGuestDetails)) {
            warningText = 'Please Select a Guest to Continue Reservation';
        }
        if (warningText) {
            this.setState({ warningText }, () => {
                let warnDom = document.getElementById('reservation-warn-container');
                if (warnDom) {
                    warnDom.setAttribute('tabindex', '-1');
                    warnDom.focus();
                }
            });
            window.scrollTo(0, this.warningRef.offsetTop + 50);
            return;
        }
        if ((reservations.cart && reservations.cart.length < 5) || inCartClass) {
            this.props.actions.addServiceToCart(service, inCartClass);
        }
        else {
            let warningText = 'Cart is Full';
            this.setState({ warningText });
            window.scrollTo(0, this.warningRef.offsetTop + 50);
        }
    }

    onClosePopUp() {
        this.setState({ showPopUp: false });
    }

    showUserList() {
        this.setState({ showUserList: true });
    }

    onCollapseClose() {
        this.setState({ showUserList: false });
    }

    render() {
        //let {users} = this.state;
        let { filter = {}, guestDetails = [], selectedService, selectedGuestDetails, PaymentDetails = {} } = this.props.services;
        let { ShipboardCurrencyCode = 'USD' } = PaymentDetails;
        let { services, reservations = {} } = this.props;
        let { selectedGuest = '', } = filter;
        let users = (services.guestNames) ? services.guestNames.map((name) => `${name.FirstName} ${name.LastName}`) : [];
        let { cart, isDatesLoading, conflictMsg } = reservations;
        return (
            <div className='service-availability-container reservation-container'>
                <div className='availablity-heading text-md-center text-left  top-spacing-30'>
                    <h2 className='mob-guest-padding font-size-p18 text-mob-left' aria-expanded="true">Select a Guest </h2>
                </div>
                <div className='availability-users-list d-none d-md-block'>
                    <span ref={(ref) => this.warningRef = ref} ></span>
                    {(this.state.warningText) &&
                        <div role='alert' id='reservation-warn-container' data-test-id='reserve-warning' className="conflict-message" >
                            {this.state.warningText}
                        </div>
                    }
                    <UsersList selectedGuestDetails={selectedGuestDetails} guestDetails={guestDetails} selectedGuest={selectedGuest} isMobile={true} onUserClick={this.onUserClick} users={users} />
                </div>
                <div className='mobile-collapse-container d-block d-md-none mobile-user-list gotham-xn-medium font-size-p2 gray-e6-bg'>
                    <span data-test-id='spa-conflict-message' ref={(ref) => this.warningRef = ref} ></span>
                    {(this.state.warningText) &&
                        <div className="conflict-message" >
                            {this.state.warningText}
                        </div>
                    }
                    <CollapseContainer onCollapseClose={this.onCollapseClose} triggerText={selectedGuest || 'Select'} isOpen={this.state.showUserList} onCollapseTriggerClick={this.showUserList} >
                        <UsersList selectedGuestDetails={selectedGuestDetails} guestDetails={guestDetails} onUserClick={this.onUserClick} users={users} isMobile={true} />
                    </CollapseContainer>
                </div>
                <span ref={(ref) => this.noteRef = ref} ></span>
                {(conflictMsg && conflictMsg.length > 0) &&
                    <div className="spa-box text-center red spa-landing-cancel-bottom">
                        {conflictMsg}
                    </div>
                }
                {selectedService.serviceGroup === 'relaxationareas' ?
                    <div>
                        <div className='availablity-heading availablity-label'>
                            <h2 className='text-mob-left font-size-p18  align-center'>Choose a Date  </h2>
                        </div>
                        <p className='align-center font-size-p2 gotham-book margin-top-0 text-mob-left  d-none d-md-block'>{`Choose a date  that you wish to reserve. `}
                            <span className="link-text">
                                <a href="javascript:void(0)" className='button-link' data-test-id="view-cancellation" onClick={this.scrollToMyRef}> View Cancellation Policy
                         </a>
                            </span>
                        </p>
                    </div>
                    :
                    <div>
                        <div className='availablity-heading availablity-label'>
                            <h2 className='text-mob-left font-size-p18  align-center'>Choose a Date & Time </h2>
                        </div>
                        <p className='align-center font-size-p2 gotham-book margin-top-0 text-mob-left  d-none d-md-block'>{`Choose a date & time that you wish to reserve. `}
                            <span className="link-text">
                                <a href="javascript:void(0)" className='button-link' data-test-id="view-cancellation" onClick={this.scrollToMyRef}> View Cancellation Policy
                         </a>
                            </span>
                        </p>
                    </div>
                }
                <p className='padding-line font-size-m4 d-md-none text-mob-left'>Select one time slot that you wish to reserve.</p>
                <p className='padding-line font-size-m2 d-md-none text-mob-left'>Items not added to booking until purchased.</p>
                <div className='padding-line link-underline font-size-m4 d-md-none  d-sm-block   text-mob-left'>
                    <a href="javascript:void(0)" className='button-link' data-test-id="view-cancellation" onClick={this.scrollToMyRef}>
                        View Cancellation Policy
                    </a>

                </div>
                {(!selectedService.isNoAvailable) ?
                    <div className='availablity-date-time reservation-dates-container margin-top-min20px'>
                        {(isDatesLoading) ?
                            <ReservationDatesLoader /> :
                            <ReservationDates services={services} ShipboardCurrencyCode={ShipboardCurrencyCode} selectedService={selectedService} cart={cart} onCardClick={this.onSelectReserveDate} onReserveService={this.onReserveService.bind(this)} reservations={reservations} />
                        }
                    </div> :
                    <div className='no-reserve-available text-center'>
                        <h2 className='red'>Service currently not available for reservations</h2>
                    </div>}
                <ConfirmPopUp title='Information' contentText={this.state.warningText} isCancel={false} onConfirm={this.onClosePopUp} onClose={this.onClosePopUp} show={this.state.showPopUp} />
            </div>
        );
    }
}



export default ReservationTimeSlots;